// extracted by mini-css-extract-plugin
module.exports = {"createAdminFlag":"ResetPasswordForm1_createAdminFlag__2W9Gf","countryCode":"ResetPasswordForm1_countryCode__2zUEu"};